import React from 'react';
import { Tab } from '../../App';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import HistoryIcon from '@mui/icons-material/History';
import { GOOGLE_SHEET_ID } from '../../helpers/sheets';

interface Props {
  open: boolean;
  onClose: () => void;
  onTabSelected: (tab: Tab) => void;
}

export default function NavDrawer(props: Props) {
  function openSheet() {
    window.open(`https://docs.google.com/spreadsheets/d/${GOOGLE_SHEET_ID}/edit#gid=0`, "_blank");
  }

  return (
    <Drawer
      anchor="left"
      open={props.open}
      onClose={props.onClose}
    >
      <Box sx={{ width: 250 }} role="presentation">
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => props.onTabSelected(Tab.AddExpense)}>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              <ListItemText primary="Add an expense" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={openSheet}>
              <ListItemIcon>
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText primary="View the sheet" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  )
}
